import { Component, OnInit } from '@angular/core';
import { ConfirmationDTO } from '../../model/confirmationDTO';
import { catchError, concat, ignoreElements, map, mergeMap, Observable, of, shareReplay, tap, throwError } from 'rxjs';
import { AuthService } from '../../_services/auth.service';
import { SharedService } from '../../_services/shared.service';
import { OfferService } from '../../_services/offer/offer.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ResponsiveMode } from '../../enum/responsiveModes';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { OfferNotAvailableComponent } from '../offer-not-available/offer-not-available.component';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-offer-confirmation-code',
  standalone: true,
  imports: [
        CommonModule,
        MatCardModule,
        OfferNotAvailableComponent,
        NgxSpinnerModule
  ],
  templateUrl: './offer-confirmation-code.component.html',
  styleUrl: './offer-confirmation-code.component.css'
})
export class OfferConfirmationCodeComponent implements OnInit {


  private propertyId: string = '';
  private offerAliasId: string = '';
  private offerSetId: string = '';  
  private offerId: string = '';
  private token: string = '';
  public offerConfirmation$!: Observable<ConfirmationDTO>;
  public offerConfirmation!: ConfirmationDTO;
  public offerErrors$: any;
  public invalidCode: boolean = false;
  public offerError: boolean = false; 

  public offer_alias_data: any = {'offerError': false,
                                  'accepted': false}

  viewMode: string = ResponsiveMode.horizontal;

  constructor(private authService: AuthService,
              public sharedService: SharedService,
              private offerService: OfferService,              
              private router: Router, 
              private route: ActivatedRoute) { 
  }

  ngOnInit(): void {
    this.propertyId = this.route.snapshot.paramMap.get('prop_id') || '';
    this.offerAliasId = this.route.snapshot.paramMap.get('alias_id') || '';
    this.offerSetId = this.route.snapshot.paramMap.get('offer_set_id') || '';    
    this.offerId = this.route.snapshot.paramMap.get('offer_id') || '';
    this.token = this.route.snapshot.paramMap.get('token') || '';
    
    const validateRequest$ = this.authService.validateRequest(this.propertyId, this.offerAliasId, this.token).pipe(shareReplay(1));
    
    const acceptOffer$ = this.offerService.setOfferAccepted(this.propertyId, this.offerAliasId, this.offerId).pipe(
      catchError(error => {
        this.offerError = true;

        let offer_alias_data = JSON.stringify({'offerError': true,
                                                'accepted': false});

        localStorage.setItem(this.offerAliasId, offer_alias_data);
        this.router.navigate(['/offerNotAvailable']);
        
        return throwError(() => error);
      }),
      shareReplay(1)
    );
    
    if(localStorage.getItem(this.offerAliasId)){
      this.offer_alias_data = JSON.parse(localStorage.getItem(this.offerAliasId)!)
    }

    this.offerError = this.offer_alias_data.offerError

    if(this.offer_alias_data.accepted === true){
      this.offerConfirmation$ = this.getConfrimationInfo(this.offerAliasId, this.propertyId).pipe(   
          catchError(err => {
          this.offerError = true;
          this.router.navigate(['/offerNotAvailable']);
          return of(err);
        }),shareReplay(1)
      );
    }
    else{

      this.offerConfirmation$ = validateRequest$.pipe(
        mergeMap(res => {
          if (res?.data === true) {
            return acceptOffer$;
          } else {
            this.invalidCode = true;
            return throwError(() => res);
          }
        }),
        mergeMap(res => {
          if (res?.data === true) {
            return this.getConfrimationInfo(this.offerAliasId, this.propertyId);
          }
          return of(null);
        }),
        tap(() => {
      
          let offer_alias_data = JSON.stringify({'offerError': false,
                                                  'accepted': true});
          localStorage.setItem(this.offerAliasId, offer_alias_data);        
          this.emailOfferUpgradeAcknowledgement().subscribe();
        }),
        catchError(err => {
          console.log('error getConfrimationInfo', err);
          this.offerError = true;
          this.router.navigate(['/offerNotAvailable']);
          return of(err);
        }),
        shareReplay(1)
      );    
    }

    this.offerErrors$ = this.offerConfirmation$.pipe(
      ignoreElements(),
      catchError(err => {
        this.router.navigate(['/offerNotAvailable']);
        return of(err);
      }),
      shareReplay(1)
    );
    

  }
  
  emailOfferUpgradeAcknowledgement(): Observable<any> {
    return this.offerService.emailOfferUpgradeAcknowledgement(this.propertyId, this.offerAliasId, this.offerSetId, this.offerId); 
  }

  getConfrimationInfo(offerAliasId: string, propertyId: string): Observable<ConfirmationDTO> {
    return this.offerConfirmation$ = this.offerService.getConfrimationInfo(offerAliasId, propertyId).pipe(shareReplay(1));
  }

  navigateToOfferStatus(){
    this.router.navigate(['/offerStatus/' + this.offerAliasId + '/' + this.propertyId ], { relativeTo: this.route })
  }


}
